import { UserData } from '@stores';

interface Mod {
  id: string;
  key: string;
  rank: number;
  level: number;
};

interface CombinedMod extends Mod {
  count: number;
  equipped?: boolean;
}

export function combineMods(mods: Mod[], userData: UserData): CombinedMod[] {
  return mods.reduce((acc, mod) => {
    const isEquipped = userData.chassis.some((c) => c.mods.some((m) => m.modId === mod.id))
      || userData.weapons.some((w) => w.mods.some((m) => m.modId === mod.id));

    const existingMod = acc.find((m) => m.key === mod.key
      && m.level === mod.level
      && m.rank === mod.rank
    );

    if (existingMod && !isEquipped) {
      existingMod.count++;
    } else {
      acc.push({ ...mod, count: 1, equipped: isEquipped });
    }
    return acc;
  }, [] as CombinedMod[]);
}